import React, { useEffect, useRef, useState } from "react";

import SectionHeader from "../sectionHeader/sectionHeader";
import "./grid-container.css";
import { getPlaylist, getAWSUrl, getYoutubePlaylist } from "../api/core";
import Anchor from "../Link/anchor";
import LazyImg from "../lazy/lazy";
import Icon from "../icon/icon";
import { formatDate, formatTimeStamp } from "../javascript/function";
import { useHistory } from "react-router-dom";
import { BORDER, VCMS, NAME } from "../../global";

const Grid = (props) => {
  const init = { playlist: [] };
  const y_init = { items: [] };
  const [alselem, setALSElem] = useState([]);
  const [alselemItem, setALSItem] = useState([]);
  const [alsplaylist, setALSPlaylist] = useState(
    VCMS === "YouTube" ? y_init : init
  );
  const [loading, isLoading] = useState(true);
  /* eslint-disable no-unused-vars */
  const [error, SetError] = useState(false);
  /* eslint-disable no-unused-vars */
  const [elemalsdisplay, setALSElemDisplay] = useState(true);

  const [viewalsAll, setViewalsAll] = useState("");
  const [viewalsLink, setviewalsLink] = useState("");
  const mounted = useRef(false);
  const [alsfirstItem, setFirstItem] = useState([]);
  const history = useHistory();
  let url = "";

  const goTo = (event, loc) => {
    history.push(loc);
  };

  useEffect(() => {
    mounted.current = true;
    const ALSElemDetail = async () => {
      if (mounted.current) {
        setALSElem(props.tabbed ? props.tabid : props.information);
        setALSElemDisplay(
          props.tabbed
            ? props.tabid.devices[0].itemVisibility
            : props.information.devices[0].itemVisibility
        );

        let arr = props.tabbed ? props.tabid.items : props.information.items;

        let farr = arr.filter(function (el) {
          return el.itemid.devices[0].itemVisibility;
        });
        let darr = [];
        let sarr = [];
        if (farr.length >= 5) {
          darr = farr.filter(function (el, index) {
            return index <= 4;
          });

          sarr = farr.filter(function (el, index) {
            return index > 4;
          });
        } else {
          sarr = farr.filter(function (el, index) {
            return index >= 0;
          });
        }

        setALSItem(sarr);
        setFirstItem(darr);

        /* eslint-disable no-unused-vars */

        if (!props.tabbed) {
          if (
            props.information.playlistId !== null &&
            props.information.playlistId !== ""
          ) {
            ALSplaylistDetail(
              props.information.playlistId,
              props.information.devices[0].itemSize
            );
          }

          props.information.viewAllVisibility === true &&
          props.information.viewAllText !== null
            ? setViewalsAll(props.information.viewAllText)
            : setViewalsAll("");
          if (
            props.information.viewAllVisibility === true &&
            props.information.viewAllPage !== null
          ) {
            const link =
              props.information.viewAllPage.pageType === "externalPage"
                ? props.information.viewAllPage.externalPage
                : props.information.viewAllPage.pageType === "internalPage"
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.internalPage
                : props.information.viewAllPage.urlName !== ""
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.urlName
                : "/" +
                  props.match.params.AppId +
                  "/page/" +
                  props.information.viewAllPage._id;
            setviewalsLink(link);
          }
          isLoading(false);
        } else {
          if (
            props.tabid.playlistId !== null &&
            props.tabid.playlistId !== ""
          ) {
            ALSplaylistDetail(
              props.tabid.playlistId,
              props.tabid.devices[0].itemSize
            );
          }

          props.tabid.viewAllVisibility === true &&
          props.tabid.viewAllText !== null
            ? setViewalsAll(props.tabid.viewAllText)
            : setViewalsAll("");
          if (
            props.tabid.viewAllVisibility === true &&
            props.tabid.viewAllPage !== null
          ) {
            const link =
              props.tabid.viewAllPage.pageType === "externalPage"
                ? props.tabid.viewAllPage.externalPage
                : props.tabid.viewAllPage.pageType === "internalPage"
                ? props.tabid.viewAllPage.internalPage
                : "/" +
                  props.match.params.AppId +
                  "/" +
                  props.tabid.viewAllPage.pageType +
                  "/" +
                  props.tabid.viewAllPage._id;
            setviewalsLink(link);
          }
          isLoading(false);
        }
      }

      /* eslint-disable no-unused-vars */
    };

    const ALSplaylistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */

      if (VCMS === "YouTube") {
        const result = await getYoutubePlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setALSPlaylist(result.data);
              isLoading(false);
            }
          },
          (error) => {
            isLoading(false);
          }
        );
      } else {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setALSPlaylist(result.data);
              isLoading(false);
            }
          },
          (error) => {
            isLoading(false);
          }
        );
      }

      /* eslint-disable no-unused-vars */
    };

    ALSElemDetail();

    return () => {
      mounted.current = false;
    };
  }, [props.information, props.match.params.AppId, props.tabid, props.tabbed]);

  if (elemalsdisplay && !error && !loading) {
    return (
      <section className="new-news-area bg-color-none grid">
        <SectionHeader
          title={alselem.displayName}
          linkTitle={viewalsAll}
          link={viewalsLink}
          header={props.header}
        ></SectionHeader>
        <div className="container-fluid">
          <div className="row que">
            {alsfirstItem.length > 0 && alsfirstItem !== null ? (
              <>
                <div className="col-sm-12 col-md-6">
                  <div className="new-news-list">
                    <div
                      className={
                        BORDER ? "single-new-news" : "single-new-news no-border"
                      }
                      onClick={(event) => {
                        goTo(
                          event,
                          alsfirstItem[0].itemid.pageType === "externalPage"
                            ? alsfirstItem[0].itemid.externalPage
                            : alsfirstItem[0].itemid.pageType === "internalPage"
                            ? alsfirstItem[0].itemid.internalPage
                            : alsfirstItem[0].itemid.pageType === "videoPage"
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              alsfirstItem[0].itemid.pageType +
                              "/" +
                              alsfirstItem[0].itemid.videoId
                            : alsfirstItem[0].itemid.urlName !== ""
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              alsfirstItem[0].itemid.urlName
                            : alsfirstItem[0].itemid.pageType +
                              "/" +
                              alsfirstItem[0].itemid._id
                        );
                      }}
                    >
                      <LazyImg
                        src={
                          alsfirstItem[0].itemid.bannerImage
                            ? getAWSUrl() +
                              alsfirstItem[0].itemid.bannerImage.imagekey
                            : ""
                        }
                        alt="post-img"
                        orient={"landscape"}
                        className={BORDER ? "" : "no-border"}
                      />
                      <div
                        className={
                          alselem.displayNameVisibility === "On Hover" ||
                          alselem.displayNameVisibility === "Show Header Only"
                            ? "news-content"
                            : alselem.displayNameVisibility === "Show Always"
                            ? "news-content viewHeader"
                            : "news-content viewNone"
                        }
                      >
                        <ul>
                          <li className="caldate">
                            <i className="icofont-calendar" />{" "}
                            {formatDate(alsfirstItem[0].itemid.date)}
                          </li>
                        </ul>
                        <h3>
                          <Anchor to="#!">
                            {alsfirstItem[0].itemid.mainHeader
                              ? alsfirstItem[0].itemid.mainHeader
                              : alsfirstItem[0].itemid.displayName}
                          </Anchor>
                        </h3>
                      </div>
                      <div className="tags bg-3">
                        <Anchor to="#!">{alsfirstItem[0].itemid.tag}</Anchor>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-3">
                  <div className="new-news-list">
                    <div
                      className={
                        BORDER ? "single-new-news" : "single-new-news no-border"
                      }
                      onClick={(event) => {
                        goTo(
                          event,
                          alsfirstItem[1].itemid.pageType === "externalPage"
                            ? alsfirstItem[1].itemid.externalPage
                            : alsfirstItem[1].itemid.pageType === "internalPage"
                            ? alsfirstItem[1].itemid.internalPage
                            : alsfirstItem[1].itemid.pageType === "videoPage"
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              alsfirstItem[1].itemid.pageType +
                              "/" +
                              alsfirstItem[1].itemid.videoId
                            : alsfirstItem[1].itemid.urlName !== ""
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              alsfirstItem[1].itemid.urlName
                            : alsfirstItem[1].itemid.pageType +
                              "/" +
                              alsfirstItem[1].itemid._id
                        );
                      }}
                    >
                      <LazyImg
                        src={
                          alsfirstItem[1].itemid.bannerImage
                            ? getAWSUrl() +
                              alsfirstItem[1].itemid.bannerImage.imagekey
                            : ""
                        }
                        alt="post-img"
                        orient={"landscape"}
                        className={BORDER ? "" : "no-border"}
                      />
                      <div
                        className={
                          alselem.displayNameVisibility === "On Hover" ||
                          alselem.displayNameVisibility === "Show Header Only"
                            ? "news-content"
                            : alselem.displayNameVisibility === "Show Always"
                            ? "news-content viewHeader"
                            : "news-content viewNone"
                        }
                      >
                        <ul>
                          <li className="caldate">
                            <i className="icofont-calendar" />{" "}
                            {formatDate(alsfirstItem[1].itemid.date)}
                          </li>
                        </ul>
                        <h3>
                          <Anchor to="#!">
                            {alsfirstItem[1].itemid.mainHeader
                              ? alsfirstItem[1].itemid.mainHeader
                              : alsfirstItem[1].itemid.displayName}
                          </Anchor>
                        </h3>
                      </div>
                      <div className="tags bg-3">
                        <Anchor to="#!">{alsfirstItem[1].itemid.tag}</Anchor>
                      </div>
                    </div>
                    <div
                      className={
                        BORDER ? "single-new-news" : "single-new-news no-border"
                      }
                      onClick={(event) => {
                        goTo(
                          event,
                          alsfirstItem[2].itemid.pageType === "externalPage"
                            ? alsfirstItem[2].itemid.externalPage
                            : alsfirstItem[2].itemid.pageType === "internalPage"
                            ? alsfirstItem[2].itemid.internalPage
                            : alsfirstItem[2].itemid.pageType === "videoPage"
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              alsfirstItem[2].itemid.pageType +
                              "/" +
                              alsfirstItem[2].itemid.videoId
                            : alsfirstItem[2].itemid.urlName !== ""
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              alsfirstItem[2].itemid.urlName
                            : alsfirstItem[2].itemid.pageType +
                              "/" +
                              alsfirstItem[2].itemid._id
                        );
                      }}
                    >
                      <LazyImg
                        src={
                          alsfirstItem[2].itemid.bannerImage
                            ? getAWSUrl() +
                              alsfirstItem[2].itemid.bannerImage.imagekey
                            : ""
                        }
                        alt="post-img"
                        className={BORDER ? "" : "no-border"}
                        orient={"landscape"}
                      />
                      <div
                        className={
                          alselem.displayNameVisibility === "On Hover" ||
                          alselem.displayNameVisibility === "Show Header Only"
                            ? "news-content"
                            : alselem.displayNameVisibility === "Show Always"
                            ? "news-content viewHeader"
                            : "news-content viewNone"
                        }
                      >
                        <ul>
                          <li className="caldate">
                            <i className="icofont-calendar" />{" "}
                            {formatDate(alsfirstItem[2].itemid.date)}
                          </li>
                        </ul>
                        <h3>
                          <Anchor to="#!">
                            {alsfirstItem[2].itemid.mainHeader
                              ? alsfirstItem[2].itemid.mainHeader
                              : alsfirstItem[2].itemid.displayName}
                          </Anchor>
                        </h3>
                      </div>
                      <div className="tags bg-3">
                        <Anchor to="#!">{alsfirstItem[2].itemid.tag}</Anchor>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-3">
                  <div className="new-news-list">
                    <div
                      className={
                        BORDER ? "single-new-news" : "single-new-news no-border"
                      }
                      onClick={(event) => {
                        goTo(
                          event,
                          alsfirstItem[3].itemid.pageType === "externalPage"
                            ? alsfirstItem[3].itemid.externalPage
                            : alsfirstItem[3].itemid.pageType === "internalPage"
                            ? alsfirstItem[3].itemid.internalPage
                            : alsfirstItem[3].itemid.pageType === "videoPage"
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              alsfirstItem[3].itemid.pageType +
                              "/" +
                              alsfirstItem[3].itemid.videoId
                            : alsfirstItem[3].itemid.urlName !== ""
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              alsfirstItem[3].itemid.urlName
                            : alsfirstItem[3].itemid.pageType +
                              "/" +
                              alsfirstItem[3].itemid._id
                        );
                      }}
                    >
                      <LazyImg
                        src={
                          alsfirstItem[3].itemid.bannerImage
                            ? getAWSUrl() +
                              alsfirstItem[3].itemid.bannerImage.imagekey
                            : ""
                        }
                        alt="post-img"
                        className={BORDER ? "" : "no-border"}
                        orient={"landscape"}
                      />
                      <div
                        className={
                          alselem.displayNameVisibility === "On Hover" ||
                          alselem.displayNameVisibility === "Show Header Only"
                            ? "news-content"
                            : alselem.displayNameVisibility === "Show Always"
                            ? "news-content viewHeader"
                            : "news-content viewNone"
                        }
                      >
                        <ul>
                          <li className="caldate">
                            <i className="icofont-calendar" />{" "}
                            {formatDate(alsfirstItem[3].itemid.date)}
                          </li>
                        </ul>
                        <h3>
                          <Anchor to="#!">
                            {alsfirstItem[3].itemid.mainHeader
                              ? alsfirstItem[3].itemid.mainHeader
                              : alsfirstItem[3].itemid.displayName}
                          </Anchor>
                        </h3>
                      </div>
                      <div className="tags bg-3">
                        <Anchor to="#!">{alsfirstItem[3].itemid.tag}</Anchor>
                      </div>
                    </div>
                    <div
                      className={
                        BORDER ? "single-new-news" : "single-new-news no-border"
                      }
                      onClick={(event) => {
                        goTo(
                          event,
                          alsfirstItem[4].itemid.pageType === "externalPage"
                            ? alsfirstItem[4].itemid.externalPage
                            : alsfirstItem[4].itemid.pageType === "internalPage"
                            ? alsfirstItem[4].itemid.internalPage
                            : alsfirstItem[4].itemid.pageType === "videoPage"
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              alsfirstItem[4].itemid.pageType +
                              "/" +
                              alsfirstItem[4].itemid.videoId
                            : alsfirstItem[4].itemid.urlName !== ""
                            ? "/" +
                              props.match.params.AppId +
                              "/" +
                              alsfirstItem[4].itemid.urlName
                            : alsfirstItem[4].itemid.pageType +
                              "/" +
                              alsfirstItem[4].itemid._id
                        );
                      }}
                    >
                      <LazyImg
                        src={
                          alsfirstItem[4].itemid.bannerImage
                            ? getAWSUrl() +
                              alsfirstItem[4].itemid.bannerImage.imagekey
                            : ""
                        }
                        alt="post-img"
                        orient={"landscape"}
                        className={BORDER ? "" : "no-border"}
                      />
                      <div
                        className={
                          alselem.displayNameVisibility === "On Hover" ||
                          alselem.displayNameVisibility === "Show Header Only"
                            ? "news-content"
                            : alselem.displayNameVisibility === "Show Always"
                            ? "news-content viewHeader"
                            : "news-content viewNone"
                        }
                      >
                        <ul>
                          <li className="caldate">
                            <i className="icofont-calendar" />{" "}
                            {formatDate(alsfirstItem[4].itemid.date)}
                          </li>
                        </ul>
                        <h3>
                          <Anchor to="#!">
                            {alsfirstItem[4].itemid.mainHeader
                              ? alsfirstItem[4].itemid.mainHeader
                              : alsfirstItem[4].itemid.displayName}
                          </Anchor>
                        </h3>
                      </div>
                      <div className="tags bg-3">
                        <Anchor to="#!">{alsfirstItem[4].itemid.tag}</Anchor>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            {alselemItem !== null
              ? alselemItem.map((item, index) =>
                  item.itemid.devices[0].itemVisibility ? (
                    <div key={index} className="col-sm-6 col-md-3">
                      <div className="new-news-list">
                        <div
                          className={
                            BORDER
                              ? "single-new-news"
                              : "single-new-news no-border"
                          }
                          onClick={(event) => {
                            goTo(
                              event,
                              item.itemid.pageType === "externalPage"
                                ? item.itemid.externalPage
                                : item.itemid.pageType === "internalPage"
                                ? item.itemid.internalPage
                                : item.itemid.pageType === "videoPage"
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.pageType +
                                  "/" +
                                  item.itemid.videoId
                                : item.itemid.urlName !== ""
                                ? "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  item.itemid.urlName
                                : item.itemid.pageType + "/" + item.itemid._id
                            );
                          }}
                        >
                          <LazyImg
                            src={
                              item.itemid.landscapeThumbnail
                                ? getAWSUrl() +
                                  item.itemid.landscapeThumbnail.imagekey
                                : ""
                            }
                            alt=""
                            orient={"landscape"}
                            className={BORDER ? "" : "no-border"}
                          />
                          <div
                            className={
                              alselem.displayNameVisibility === "On Hover" ||
                              alselem.displayNameVisibility ===
                                "Show Header Only"
                                ? "news-content"
                                : alselem.displayNameVisibility ===
                                  "Show Always"
                                ? "news-content viewHeader"
                                : "news-content viewNone"
                            }
                          >
                            <ul>
                              <li className="caldate">
                                <i className="icofont-calendar" />{" "}
                                {formatDate(item.itemid.date)}
                              </li>
                            </ul>
                            <h3>
                              <Anchor to="#!">
                                {" "}
                                {item.itemid.mainHeader
                                  ? item.itemid.mainHeader
                                  : item.itemid.displayName
                                  ? item.itemid.displayName
                                  : item.itemid.description}
                              </Anchor>
                            </h3>
                          </div>
                          <div className="tags bg-4">
                            <a href="#!">{item.itemid.tag}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                )
              : ""}

            {alselem.playlistId !== null && alselem.playlistId !== undefined
              ? VCMS === "YouTube"
                ? alsplaylist.items.map((item, index) => (
                    <div key={index} className={"col-sm-6 col-md-3"}>
                      <div className="new-news-list">
                        <div
                          className={
                            BORDER
                              ? "single-new-news"
                              : "single-new-news no-border"
                          }
                          onClick={(event) =>
                            goTo(
                              event,
                              "/" +
                                props.match.params.AppId +
                                "/videoPage/" +
                                item.contentDetails.videoId
                            )
                          }
                        >
                          <LazyImg
                            src={item.snippet.thumbnails.medium.url}
                            alt=""
                            orient={"landscape"}
                            className={BORDER ? "" : "no-border"}
                          />
                          <div
                            className={
                              alselem.displayNameVisibility === "On Hover" ||
                              alselem.displayNameVisibility ===
                                "Show Header Only"
                                ? "news-content"
                                : alselem.displayNameVisibility ===
                                  "Show Always"
                                ? "news-content viewHeader"
                                : "news-content viewNone"
                            }
                          >
                            <ul>
                              <li className="caldate">
                                <i className="icofont-calendar" />{" "}
                                {formatTimeStamp(item.snippet.publishedAt)}
                              </li>
                            </ul>
                            <h3>
                              <Anchor to="#!"> {item.snippet.title}</Anchor>
                            </h3>
                          </div>
                          <div className="tags bg-4">
                            <Anchor to="#!">{NAME}</Anchor>
                          </div>
                          {/* {item.ContentType==="Premium"?<div className="floated">
                        <Icon></Icon>
                        </div>:""} */}
                        </div>
                      </div>
                    </div>
                  ))
                : alsplaylist.playlist.map((item, index) => (
                    <div key={index} className="col-sm-6 col-md-3">
                      <div className="new-news-list">
                        <div
                          className={
                            BORDER
                              ? "single-new-news"
                              : "single-new-news no-border"
                          }
                          onClick={(event) =>
                            goTo(
                              event,
                              "/" +
                                props.match.params.AppId +
                                "/videoPage/" +
                                item.mediaid
                            )
                          }
                        >
                          <LazyImg
                            src={item.images[0].src}
                            alt=""
                            orient={"landscape"}
                            className={BORDER ? "" : "no-border"}
                          />
                          <div
                            className={
                              alselem.displayNameVisibility === "On Hover" ||
                              alselem.displayNameVisibility ===
                                "Show Header Only"
                                ? "news-content"
                                : alselem.displayNameVisibility ===
                                  "Show Always"
                                ? "news-content viewHeader"
                                : "news-content viewNone"
                            }
                          >
                            <ul>
                              <li className="caldate">
                                <i className="icofont-calendar" />{" "}
                                {formatTimeStamp(item.pubdate)}
                              </li>
                            </ul>
                            <h3>
                              <Anchor to="#!"> {item.title}</Anchor>
                            </h3>
                          </div>
                          <div className="tags bg-4">
                            <Anchor to="#!">{item.Plan}</Anchor>
                          </div>
                          {item.ContentType === "Premium" ? (
                            <div className="floated">
                              <Icon></Icon>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  ))
              : ""}
          </div>
        </div>
      </section>
    );
  } else if (elemalsdisplay && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }
};

export default Grid;
